<template>
	<div class="container">
		<p class="conentTitle">招商加盟</p>
		<ul class="attract">
			<li @click="num=0">
				<p :class="{active:num==0}">-01-</p>
				<p style="color:#666666">加盟条件</p>
				<p>更多</p>
				<p><img src="../../../public/images/join/pic1.png" alt="" /></p>
			</li>
			<li @click="num=1">
				<p :class="{active:num==1}">-02-</p>
				<p style="color:#666666">服务提供商</p>
				<p>更多</p>
				<p><img src="../../../public/images/join/pic3.png" alt="" /></p>
			</li>
			<li @click="num=2">
				<p :class="{active:num==2}">-03-</p>
				<p style="color:#666666">产品提供商</p>
				<p>更多</p>
				<p><img src="../../../public/images/join/pic2.png" alt="" /></p>
			</li>
		</ul>
		<div class="conent" v-show="num==0">
			<p class="conentTitle">加盟条件</p>
			<ul>
				<li>1、核心团队拥有2年以上的养老服务、运营经验，拥有健全的服务团队结构；</li>
				<li>2、具备基础的运营资金储备，善于搭建和培养服务团队，拥有一定的推广能力；</li>
				<li>3、与当地政府、社区、媒体有良好的合作与互动关系；</li>
				<li>4、热爱养老事业，拥有端正的运营服务态度；</li>
				<li>5、对智慧养老具有一定的认知，团队学习能力良好，愿意接纳新生事物，服从智慧养老建设工程项目的相关工作安排；</li>
				<li>6、遵纪守法，3年内无不良经营记录。</li>
			</ul>
		</div>
		<div class="conent" v-show="num==1">
			<p class="conentTitle">服务提供商</p>
			<ul>
				<li>1、具备完备的专业服务资质的经营主体；</li>
				<li>2、遵纪守法，3年内无不良经营记录；</li>
				<li>3、愿意加入中国老龄事业发展基金会智慧养老建设工程，成为服务提供商；</li>
				<li>4、严格保障服务的品质与服务安全；</li>
				<li>5、服务类型包括面向老年人的助餐、助洁、助行、助浴、助急、助医、助安、助学、助聊、助乐、适老化改造、心理慰藉、法律援助、家政等服务；</li>
				<li>6、欢迎公益组织、志愿者组织、爱心企业积极加入，让天下老人老有所助。</li>
			</ul>
		</div>
		<div class="conent" v-show="num==2">
			<p class="conentTitle">产品提供商</p>
			<ul>
				<li>1、具备完备的产品生产与经营资质的经营主体；</li>
				<li>2、遵纪守法，3年内无不良经营记录；</li>
				<li>3、愿意加入中国老龄事业发展基金会智慧养老建设工程，成为适老化产品提供商；</li>
				<li>4、严格保障产品的品质与安全；</li>
				<li>5、产品类型包括面向老年人的助老辅具、老年生活用品、营养食品等产品；</li>
				<li>6、欢迎全国各地知名品牌适老化产品提供商及爱心企业积极加入，为天下老人提供高品质的适老产品。</li>
			</ul>
		</div>
		<p class="conentTitle">在线留言</p>
		<div class="message">
			<leave-message></leave-message>
			<p class="sub">
				<el-button class="submit">提交</el-button>
			</p>
			
		</div>
	</div>
</template>

<script>
import leaveMessage from '@/components/leave_message.vue';
export default {
	components: {
		leaveMessage
	},
	data() {
		return {
			num:0,
		};
	},
	
	methods: {
		
	},
	
};
</script>

<style scoped="scoped">
	.active{
		color: #70c2f2!important;
	}
.container {
	padding: 0 16%;
}
.conentTitle {
	text-align: center;
	font-size: 34px;
	padding: 40px 0;
	color: #666666;
}
.attract {
	display: flex;
	justify-content: space-between;
}
.attract li {
	width: 30%;
	background: #eff3f6;
	cursor: pointer;
}
.attract li > p {
	text-align: center;
}
.attract li > p:first-of-type {
	color: #cccccc;
	font-size: 36px;
	padding: 16px 0;
}
.attract li > p:nth-of-type(2) {
	font-size: 32px;
}

.attract li > p:nth-of-type(3) {
	color: #818181;
	font-size: 18px;
	padding: 6px 0 50px 0;
}
.attract li > p:nth-of-type(4) > img {
	width: 100%;
	height: 320px;
}
.conent {
}
.conent > ul {
	font-size: 24px;
	color: #797979;
	padding: 0 100px;
}
.conent > ul > li {
	line-height: 42px;
}
 .message {
	/* height:460px; */
}
.sub{
	text-align: center;
	margin:40px 0;
}
.submit {
	background: #70c2f2;
	color: #fff;
	outline: none;
	width: 140px;
	font-size: 20px;
	
}
</style>
